import React, { useState, useEffect } from "react";
import ic_car_outline from "../img/ic_mirror_1.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import Header from "./Header";
import axios from "axios";

function ShowCategory() {

    const [searchParams, setSearchParams] = useSearchParams();
    const makename = searchParams.get('makename');
    const modelname = searchParams.get('modelname');
    const modelyear = searchParams.get('modelyear');
    
    console.log("makeName ", makename);
    console.log("modelname ", modelname);
    console.log("modelyear ", modelyear);
    

    const [categoryNameList, setCategoryNameList] = useState(null)

    const navigate = useNavigate()

    const clickedOnModel = (maincategory) => {

        navigate(`/show_sub_category?makename=${makename}&modelname=${modelname}&modelyear=${modelyear}&maincategory=${maincategory}`)

    }

    const callAPIToGetCategoryNames = () => {

        axios.get('https://cubixweberp.com:197/api/InventMasters/InventoryLevel4?cmpcode=AUTOLAND&guid=82D38C38-65BF-46AF-8871-D8219757842C&mod=LEVEL4&lvl1=A1&lvl2=A2&lvl3=A3').then((res) => {

            groupMainCategory(res.data)

        }).catch((err) => {
            console.log("err ", err)
        })
    }

    const groupMainCategory = (tech) => {


        const groupedTech = Object.entries(
            // What you have done
            tech.reduce((acc, { group, GroupDesc, MainCatergory }) => {
                // Group initialization
                if (!acc[MainCatergory]) {
                    acc[MainCatergory] = [];
                }

                // Grouping
                // FIX: only pushing the object that contains id and value
                acc[MainCatergory].push({ group, MainCatergory });

                return acc;
            }, {})
        ).map(([label, options]) => ({ label, options }));

        console.log("groupedTech ", groupedTech);

        localStorage.setItem("autoland_group_and_subgroup", JSON.stringify( groupedTech ) )
        setCategoryNameList(groupedTech)
    }

    useEffect(() => {

        callAPIToGetCategoryNames()

    }, [])

    return (
        <div className="ShowModel-root-container">

            <div className="Header-wrapper">
                <Header />
            </div>

            <div className="Show-container p-4">

                <h6>Select Category</h6>

                <div className="Show-container-inner">

                    {
                        categoryNameList?.map((item) => {


                            if (item.label == "") {

                                return (

                                    <div className="list-item-single" onClick={() => clickedOnModel()}>
                                        <img className="make_logo me-2" src={`http://autoland1.fortiddns.com:83/main_category/others.jpg`} />
                                        <p>Others ( <span className="other_category_names">{item.options.map((othername) => {
                                            return (

                                                <span>
                                                     {othername.group},
                                                </span>
                                            )
                                        }
                                        )}</span> )</p>
                                    </div>
                                )
                            } else {
                                return (
                                    <div className="list-item-single" onClick={() => clickedOnModel(item.label)}>
                                        <img className="make_logo me-2" src={`http://autoland1.fortiddns.com:83/main_category/${item.label.replace(/ +/g, "").trim()}.jpg`} />
                                        <p>{item.label}</p>
                                    </div>
                                )
                            }


                        })
                    }


                </div>

            </div>

        </div>
    )
}

export default ShowCategory;